<template>
  <v-app>
    <div class="loading-curtain" v-if="loading" />
    <div class="loading-icon" v-if="loading">
      <LoaderIcon width="96" height="54" />
    </div>
    <transition name="pages-fade" mode="out-in">
      <router-view />
    </transition>

    <BtnNovaVersaoDisponivel
      v-if="getPossuiUpdate"
      :callback="recarregarPaginaAndAtualizarVersao"
    />

    <Snackbar />
  </v-app>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Hotjar from '@hotjar/browser';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';

const LoaderIcon = () => import('@/components/icons/LoaderIcon.vue');
const Snackbar = () => import('@/components/misc/Snackbar.vue');
const BtnNovaVersaoDisponivel = () => import('@/components/common/BtnNovaVersaoDisponivel.vue');

export default {
  name: 'App',
  components: { LoaderIcon, Snackbar, BtnNovaVersaoDisponivel },
  computed: {
    ...mapState(['loading', 'darkTheme']),
    ...mapGetters('idiomas', ['getIdioma']),
    ...mapGetters('core', ['getManutencao']),
    ...mapGetters(['getPossuiUpdate']),
    ...mapState(['versaoTrinity', 'versaoTrinityServidor', 'versaoTrinityClient']),
  },
  watch: {
    getManutencao(isManutencao) {
      if (isManutencao) {
        this.$router.push('/manutencao');
      } else {
        this.$router.push('/');
      }
    },
  },
  methods: {
    ...mapActions(['toggleLoading', 'initializeStore']),
    ...mapActions('core', ['verificarManutencao']),
    ...mapActions(['fetchVersaoServidor', 'atualizarVersaoClient', 'inicializarVersaoClient']),
    recarregarPaginaAndAtualizarVersao() {
      this.atualizarVersaoClient(this.versaoTrinityServidor);
      window.location.reload();
    },
    inicializarHeatMap() {
      const { VUE_APP_HOTJAR_SITE_ID: siteId, VUE_APP_HOTJAR_VERSION: version } = process.env;
      let inicializarHotjar = true;

      if (!siteId) {
        console.warn('Hotjar "Site ID" ausente');
        inicializarHotjar = false;
      }

      if (!version) {
        console.warn('Hotjar "Version" ausente');
        inicializarHotjar = false;
      }

      if (inicializarHotjar) {
        Hotjar.init(siteId, version);
      }
    },
  },
  created() {
    this.initializeStore();

    const theme = localStorage.getItem('darkTheme');

    if (theme) {
      if (theme === 'true') {
        this.$vuetify.theme.dark = true;
        document.body.classList.remove('light');
        document.body.classList.add('dark');
      } else {
        this.$vuetify.theme.dark = false;
        document.body.classList.remove('dark');
        document.body.classList.add('light');
      }
    }

    this.$vuetify.lang.current = this.getIdioma;
  },
  async mounted() {
    await this.fetchVersaoServidor();

    this.inicializarVersaoClient();

    if (performance.getEntriesByType('navigation')[0].type === 'reload' && this.getPossuiUpdate) {
      this.atualizarVersaoClient(this.versaoTrinityServidor);
    }

    this.inicializarHeatMap();
  },
  updated() {
    this.fetchVersaoServidor();
  },
};
</script>

<style lang="scss">
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-material.css";

.ag-theme-material {
  --ag-font-family: 'Inter';
  --ag-header-height: 40px;
  --ag-background-color: var(--background);
  --ag-odd-row-background-color: #ffffff;
  --ag-header-foreground-color: var(--text);
  --ag-header-background-color: #eeeeee;
  --ag-checkbox-checked-color: var(--secondary);
}

.dark-mode .ag-theme-material {
  --ag-font-family: 'Inter';
  --ag-header-height: 40px;
  --ag-background-color: var(--dark-background);
  --ag-odd-row-background-color: #25262E;
  --ag-foreground-color: var(--white);
  --ag-header-foreground-color: var(--white);
  --ag-header-background-color: #1E1E1E;
  --ag-header-cell-hover-background-color: #1E1E1E;
  --ag-checkbox-checked-color: var(--secondary);
}

.ag-theme-material .ag-header,
.ag-theme-material .ag-row {
  border-bottom: none !important;
}

.ag-theme-material .ag-header-cell {
  font-size: 0.8rem;
  border-right: 4px solid #f5f5f5;
  border-bottom: 1px solid #d1d1d1;
}

.dark-mode .ag-theme-material .ag-header-cell {
  font-size: 0.8rem;
  border-right: 4px solid var(--dark-background);
  border-bottom: 1px solid var(--dark-background);
}
</style>
